import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import {
  AlertCircle,
  CheckCircle2,
  Info,
  TriangleAlert,
  X,
} from "lucide-react";

type QuoteModalType = "success" | "warning" | "error" | "default";

const typeMap: Record<
  QuoteModalType,
  { icon: React.ReactNode; title: string; color: string }
> = {
  success: {
    icon: <CheckCircle2 className="w-6 h-6 text-green-600" />,
    title: "Sucesso!",
    color: "text-green-700",
  },
  warning: {
    icon: <TriangleAlert className="w-6 h-6 text-yellow-600" />,
    title: "Atenção!",
    color: "text-yellow-700",
  },
  error: {
    icon: <AlertCircle className="w-6 h-6 text-red-600" />,
    title: "Erro!",
    color: "text-red-700",
  },
  default: {
    icon: <Info className="w-6 h-6 text-n-text-neutral" />,
    title: "Aviso",
    color: "text-n-text",
  },
};

interface QuoteFeedbackModalProps {
  open: boolean;
  onClose: () => void;
  type?: QuoteModalType;
  message: string;
}

export function QuoteFeedbackModal({
  open,
  onClose,
  type = "default",
  message,
}: QuoteFeedbackModalProps) {
  const { icon, title, color } = typeMap[type];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-sm">
        <DialogHeader className="flex flex-row items-center gap-3">
          {icon}
          <DialogTitle className={cn("text-lg", color)}>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm text-muted-foreground mt-2">
          {message}
        </DialogDescription>
        <div className="flex font-normal justify-end mt-4">
          <Button onClick={onClose} variant="default">
            Fechar <X className="ml-1" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
